import { render, staticRenderFns } from "./Crmintegration.vue?vue&type=template&id=281e5584&scoped=true&"
import script from "./Crmintegration.vue?vue&type=script&lang=js&"
export * from "./Crmintegration.vue?vue&type=script&lang=js&"
import style0 from "./Crmintegration.vue?vue&type=style&index=0&id=281e5584&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281e5584",
  null
  
)

export default component.exports